import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Sparkles, Activity, User, Target, Zap } from 'lucide-react';

const iconMap = {
  Sparkles,
  Activity,
  User,
  Target,
  Zap
};

const Services = ({ services }) => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white via-cyan-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title mb-4 bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">Our Services</h2>
          <p className="section-description">
            Comprehensive wellness solutions tailored to your unique needs
          </p>
          <p className="text-sm text-gray-500 mt-2 italic">
            Additional services available – Contact us to learn more
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="service-card group hover:shadow-2xl transition-all duration-300 border-2 hover:border-cyan-300"
              >
                <CardHeader>
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900 group-hover:text-cyan-600 transition-colors">
                    {service.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-gray-600 mb-4">
                    {service.description}
                  </CardDescription>
                  
                  {service.hasPricing ? (
                    <div className="pricing-section mt-6 p-4 bg-gradient-to-r from-cyan-50 to-teal-50 rounded-lg border border-cyan-200">
                      <h4 className="font-semibold text-gray-900 mb-3 text-lg">Pricing</h4>
                      <div className="space-y-2">
                        {service.pricing.map((price, idx) => (
                          <div key={idx} className="flex justify-between items-center">
                            <span className="text-gray-700 font-medium">{price.duration}</span>
                            <span className="text-xl font-bold text-cyan-600">{price.price}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="mt-6 p-4 bg-gradient-to-r from-amber-50 to-orange-50 rounded-lg border border-amber-200">
                      <p className="text-center font-semibold text-orange-600 text-lg">
                        Contact for Pricing
                      </p>
                    </div>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
